var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.96917C12.7329 4.13875 13.8053 3.61499 15 3.61499C17.2091 3.61499 19 5.40585 19 7.61499C19 9.82413 17.2091 11.615 15 11.615C13.8053 11.615 12.7329 11.0912 12 10.2608M15 21.615H3V20.615C3 17.3013 5.68629 14.615 9 14.615C12.3137 14.615 15 17.3013 15 20.615V21.615ZM15 21.615H21V20.615C21 17.3013 18.3137 14.615 15 14.615C13.9071 14.615 12.8825 14.9072 12 15.4177M13 7.61499C13 9.82413 11.2091 11.615 9 11.615C6.79086 11.615 5 9.82413 5 7.61499C5 5.40585 6.79086 3.61499 9 3.61499C11.2091 3.61499 13 5.40585 13 7.61499Z",
    stroke: "#059669",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/ActiveUsers.8a3bf3ab1b069b9250a607fc073a697a.svg";
export { ForwardRef as ReactComponent };